import React from "react";
import { Search } from "lucide-react";

/**
 * Hero réutilisable (façon « Skills Academy ») — bandeau sombre dégradé,
 * accent ambre, icône/mascotte, titre, sous-titre, recherche et élément droit.
 *
 * Props :
 *  - iconSrc   : src d'une image (mascotte) pour l'avatar
 *  - icon      : node lucide (alternative à iconSrc) rendu dans l'avatar
 *  - title     : node complet du titre (prioritaire)
 *  - titleAmber: 1er mot en ambre italique (si pas de `title`)
 *  - titleRest : suite du titre en blanc (si pas de `title`)
 *  - tagline   : sous-titre
 *  - search    : { value, onChange, placeholder } → affiche la barre de recherche
 *  - right     : node aligné à droite (anneau, stat, actions…)
 */
const AcademyHero = ({
  iconSrc,
  icon,
  title,
  titleAmber,
  titleRest,
  tagline,
  search,
  right,
}) => {
  const hasAvatar = iconSrc || icon;
  return (
    <div className="academy-hero">
      {hasAvatar ? (
        <span
          className={`academy-hero-avatar${
            icon && !iconSrc ? " academy-hero-avatar--icon" : ""
          }`}
        >
          {iconSrc ? <img src={iconSrc} alt="" aria-hidden="true" /> : icon}
        </span>
      ) : null}

      <div className="academy-hero-main">
        <h1 className="skills-academy">
          {title ? (
            title
          ) : (
            <>
              {titleAmber ? <span className="sa-skills">{titleAmber}</span> : null}
              {titleAmber && titleRest ? " " : null}
              {titleRest}
            </>
          )}
        </h1>
        {tagline ? <p className="academy-hero-tagline">{tagline}</p> : null}
      </div>

      {search ? (
        <div className="formations-search">
          <Search size={16} />
          <input
            placeholder={search.placeholder}
            value={search.value}
            onChange={search.onChange}
          />
        </div>
      ) : null}

      {right ? <div className="academy-hero-right">{right}</div> : null}
    </div>
  );
};

export default AcademyHero;
